<template>

  <img
      height="45"
      class="routeleaf-emblem"
      alt="RouteLeaf Emblem"
      :src="require('@/assets/img/routeleaf-emblem.png')"
      @click="handleClick" />

</template>

<script>
export default {
  name: 'RouteLeafEmblem',

  props: {
    linkTo: {
      type: String,
      default: null
    }
  },

  methods: {
    handleClick () {
      if (this.linkTo) this.$root.goTo(this.linkTo)
    }
  }
}
</script>

<style>
  .routeleaf-emblem {
    cursor: pointer;
    margin-top: 12px;
    margin-bottom: 6px;
  }
</style>
